import { Stage, Cell, Player } from './types';

export const STAGE_WIDTH = 10;
export const STAGE_HEIGHT = 20;

// Create a new stage filled with empty cells
export const createStage = (): Stage =>
  Array.from({ length: STAGE_HEIGHT }, () =>
    Array.from({ length: STAGE_WIDTH }, (): Cell => [0, 'clear'])
  );

// Check for collision of player tetromino on the stage
export const checkCollision = (
  player: Player,
  stage: Stage,
  { x: moveX, y: moveY }: { x: number; y: number }
): boolean => {
  for (let y = 0; y < player.tetromino.length; y++) {
    for (let x = 0; x < player.tetromino[y].length; x++) {
      // Skip empty cells in the tetromino
      if (player.tetromino[y][x] !== 0) {
        const nextY = y + player.pos.y + moveY;
        const nextX = x + player.pos.x + moveX;
        
        // Boundary checks - outside stage boundaries means collision
        const outsideGameHeight = nextY >= STAGE_HEIGHT;
        const outsideGameWidth = nextX < 0 || nextX >= STAGE_WIDTH;
        
        if (outsideGameHeight || outsideGameWidth) {
          return true;
        }
        
        // If we're trying to move up out of bounds, no collision
        if (nextY < 0) {
          continue;
        }
        
        // Check for collision with existing blocks
        if (stage[nextY][nextX][1] !== 'clear') {
          return true;
        }
      }
    }
  }
  return false;
};

// Rotate a matrix (tetromino shape)
export const rotate = (matrix: (string | number)[][], dir: number) => {
  // Transpose rows and columns
  const rotated = matrix.map((_, index) =>
    matrix.map(col => col[index])
  );
  // Reverse rows to rotate clockwise, columns for counterclockwise
  if (dir > 0) return rotated.map(row => row.reverse());
  return rotated.reverse();
};